import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useContext, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import LinearBuffer from "../../components/LinearBuffer";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import PreviewMessage from "../../components/PreviewMessage";
import SelectConection from "../../components/SelectConection";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const ContactSchema = Yup.object().shape({
  csv: Yup.string().required("Required"),
  model: Yup.string().required("Required"),
});

export const RenderForm = ({
  classes,
  contact,
  handleSaveContact,
  selectedQueueIds,
  setSelectedQueueIds,
  progressMessage,
  handlePreview,
  handleChangeMedias
}) => {
  return (
    <div className={classes.root}>
      <Formik
        initialValues={contact}
        enableReinitialize={true}
        validationSchema={ContactSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            handleSaveContact(values, actions);
          }, 400);
        }}
      >
        {({ values, errors, touched, isSubmitting, onChange }) => (
          <Form>
            <div>
              <SelectConection
                selectedQueueIds={selectedQueueIds}
                onChange={(selectedIds) => setSelectedQueueIds(selectedIds)}
              />
              <Field
                as={TextField}
                label="Template Message"
                type="model"
                multiline
                minRows={10}
                fullWidth
                name="model"
                error={touched.model && Boolean(errors.model)}
                helperText={touched.model && errors.model}
                variant="outlined"
                margin="dense"
              />

              <Field
                as={TextField}
                label="Data"
                type="csv"
                multiline
                minRows={5}
                fullWidth
                name="csv"
                error={touched.csv && Boolean(errors.csv)}
                helperText={touched.csv && errors.csv}
                variant="outlined"
                margin="dense"
              />
              <input
                type="file"
                name="media"
                id="upload-button"
                onChange={handleChangeMedias}
              />

              {/* <DataTable className={classes.btnWrapper} /> */}

              <LinearBuffer progressMessage={progressMessage} />
            </div>
            <div>
              <Button
                variant="contained"
                color="secondary"
                disabled={isSubmitting}
                onClick={() => handlePreview(values)}
                className={classes.btnWrapper}
              >
                Show preview
              </Button>

              <Button
                type="submit"
                color="primary"
                disabled={isSubmitting}
                variant="contained"
                className={classes.btnWrapper}
              >
                Send Message
                {isSubmitting && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const Contacts = () => {
	const { user } = useContext(AuthContext);
  const history = useHistory();
  const classes = useStyles();
  const isMounted = useRef(true);
  const [selectedQueueIds, setSelectedQueueIds] = useState();
  const [progressMessage, setProgressMessage] = useState(0);
  const [startSendMessage, ] = useState(false);
  const [message, setMessage] = useState([]);
  const [medias, setMedias] = useState([]);
  const initialState = {
    csv: "",
    model: "",
  };

  const [contact, setContact] = useState(initialState);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    setContact(initialState);
    setProgressMessage(0);
  };

  const formatNumber = (number) => {
    if(!number) toastError("Invalid number");
    if (number.length > 11 && number.startsWith("62")) {
        return `${number}`;
    } else if (number.startsWith("0")) {
        return `62${number.slice(1)}`;
    } else {
        return `62${number}`;
    }
  };

  const handleSaveContact = async (values, actions) => {
    try {

      if(!values.csv || !values.model) {
        toast.error("Fill in all fields");
        actions.setSubmitting(false);
        return;
      }

      if(!selectedQueueIds) {
        toast.error("Select a connection");
        actions.setSubmitting(false);
        return;
      }

      let { csv, model } = values;
      const csvHeader = csv.slice(0, csv.indexOf("\n")).split(",");
      const csvRows = csv.slice(csv.indexOf("\n") + 1).split("\n");

      const array = csvRows.map((i) => {
        const values = i.split(",");
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index];
          return object;
        }, {});
        return obj;
      });

      let rawMsg = [];
      let listMessage = [];

      array.forEach((value, index) => {
        rawMsg.push(model.replace(/\{([^}]+)\}/g, (match, key) => value[key]));
      });

      array.forEach(async (value, index) => {
        const getValueObject = Object.values(value);
        listMessage.push({
          message: rawMsg[index],
          phone: formatNumber(getValueObject[0]),
          whatsappId: selectedQueueIds,
          userId: user.id,
        });
      });
      const formData = new FormData();
      if (medias.length > 0) {
        medias.forEach((media) => {
          formData.append("media", media);
          formData.set("body", JSON.stringify(listMessage));
        });
      } else {
        formData.set("body", JSON.stringify(listMessage));
      }
      try {
       await api.post("/bulkMessage", formData);
        handleClose();
        actions.setSubmitting(false);

        toast.success(`${listMessage.length} Message saved to database successfully`);
      } catch (error) {
        toastError(error);
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handlePreview = async (values) => {
    try {
      let { csv, model } = values;
      const csvHeader = csv.slice(0, csv.indexOf("\n")).split(",");
      const csvRows = csv.slice(csv.indexOf("\n") + 1).split("\n");

      const array = csvRows.map((i) => {
        const values = i.split(",");
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index];
          return object;
        }, {});
        return obj;
      });

      let rawMsg = [];
      let listMessage = [];

      array.forEach((value, index) => {
        rawMsg.push(model.replace(/\{([^}]+)\}/g, (match, key) => value[key]));
      });


      array.forEach(async (value, index) => {
        const getValueObject = Object.values(value);
        listMessage.push({
          message: rawMsg[index],
          phone: formatNumber(getValueObject[0]),
          whatsappId: selectedQueueIds,
        });
      });

      setMessage(listMessage);
    } catch (err) {
      toastError(err);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
  };

  const goToSetting = () =>{
    let path = `SettingsMessage`;
    history.push(path);
  }

  const goToReport = () =>{
    let path = `ShippingReport`;
    history.push(path);
  }

  return (
    <MainContainer className={classes.mainContainer}>
      <MainHeader>
        <Title>Message Sending</Title>
        <MainHeaderButtonsWrapper>
          <Button
            variant="contained"
            color="primary"
            onClick={goToReport}
          >
            Report
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={goToSetting}
          >
            Setting
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <RenderForm
          classes={classes}
          contact={contact}
          setContact={setContact}
          selectedQueueIds={selectedQueueIds}
          setSelectedQueueIds={setSelectedQueueIds}
          progressMessage={progressMessage}
          setProgressMessage={setProgressMessage}
          startSendMessage={startSendMessage}
          handleSaveContact={handleSaveContact}
          handlePreview={handlePreview}
          handleChangeMedias={handleChangeMedias}
        />

        <div>
          {message.length > 0 && (
            <PreviewMessage
              message={message}
            />
          )}
        </div>
      </Paper>
    </MainContainer>
  );
};

export default Contacts;